import React from 'react';
import { string } from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';

const OrderNumberAgencyName = ({ orderNumber, agencyName, orderReviewModel }) => {
  const enableOrderLinegroup = orderReviewModel === 'ORDERLINE_GROUP';
  return <div className="order-number-agency">
    <div className="order-number">
      <span className="order-number__title">
        <Locale id="checkout.lib.components.paymentResult.orderNumber" />
      </span>
      <span className="order-number__value">{orderNumber}</span>
    </div>
    {
      enableOrderLinegroup
    && <div className="agency-name">
      { agencyName && <Locale id="checkout.lib.components.text.soldBy" params={{ 0: agencyName }}/>}
    </div>
    }
  </div>;
};

OrderNumberAgencyName.propTypes = {
  agencyName: string,
  orderNumber: string,
  orderReviewModel: string,
};

OrderNumberAgencyName.defaultProps = {
  orderReviewModel: undefined,
};

export default OrderNumberAgencyName;
